import React, { useState } from 'react'
import './FrequentlyAsked.css'
import { FaRegArrowAltCircleDown, FaRegArrowAltCircleUp } from "react-icons/fa";

const faqs = [
  {
    q: 'How quickly are bank transfers processed?',
    a: 'Most transfers are completed instantly — typically within seconds. In rare cases involving high traffic or bank maintenance, transfers may take up to 5 minutes. If a transfer is pending after 10 minutes, please contact our support team.',
  },
  {
    q: 'Which cryptocurrencies does Sendcheap support?',
    a: 'We currently support Bitcoin (BTC), Ethereum (ETH), Tether (USDT), Solana (SOL), BNB, and USD Coin (USDC). We convert your crypto to Naira at competitive rates and pay directly to any Nigerian bank account.',
  },
  {
    q: 'How do I buy airtime or data on Sendcheap?',
    a: 'Open the app, tap "Airtime & Data", select your network (MTN, Airtel, Glo, or 9mobile), enter the phone number and amount, then confirm. Your airtime or data bundle is delivered instantly.',
  },
  {
    q: 'Is Sendcheap safe? How is my money protected?',
    a: 'Yes. Sendcheap partners with CBN-licensed financial institutions and uses bank-grade encryption to protect all transactions. Your wallet funds are held securely with our regulated banking partners.',
  },
  {
    q: 'What do I do if a transaction fails or is pending?',
    a: 'If a debit was made but the transaction did not complete, your funds will be reversed automatically within 24 hours. You can also contact us at business@sendcheap.ng or call +234-701-7215143 and our team will resolve it promptly.',
  },
];

const FrequentlyAsked = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className='frequently'>
      <div className="frequently-left">
        <div className="frequently-badge">
          <p>FAQ</p>
        </div>
        <h2>Frequently Asked Questions</h2>
        <p className='frequently-headertext'>
          SendCheap is Nigeria's all-in-one payment platform. Bank transfers, airtime &amp; data, bill payments, and crypto — all in one place.
        </p>
      </div>

      <div className="frequently-right">
        {faqs.map((faq, i) => (
          <div className="frequently-right-list" key={i}>
            <div className='right-list'>
              <p>{faq.q}</p>
              {openIndex === i && <span>{faq.a}</span>}
            </div>
            {openIndex !== i
              ? <FaRegArrowAltCircleDown className='arrow-icon-1' onClick={() => toggle(i)} />
              : <FaRegArrowAltCircleUp className='arrow-icon-1' onClick={() => toggle(i)} />
            }
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrequentlyAsked;
